import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import { TopBar } from './TopBar';
import { OfflineBanner } from '@/components/common/OfflineBanner';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import { LevelUpModal } from '@/components/gamification/LevelUpModal';
import { AchievementToastHost } from '@/components/gamification/AchievementToastHost';
import { PWAUpdatePrompt } from '@/components/common/PWAUpdatePrompt';
import { PageTransition } from '@/components/common/PageTransition';

export function AppShell() {
  const isDesktop = useIsDesktop();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <div className="min-h-[100dvh] bg-parchment-light text-parchment-ink">
      <OfflineBanner />
      <div className="flex">
        {isDesktop && <Sidebar />}
        {/* min-w-0: without it a wide child (e.g. the heatmap SVG) grows this
            flex item past the viewport and the whole page scrolls sideways. */}
        <div className="flex min-w-0 flex-1 flex-col">
          <TopBar />
          <main
            className="flex-1 px-4 pb-24 pt-4 sm:px-6 lg:px-8 lg:pb-8"
            id="main-content"
          >
            <div className="mx-auto w-full max-w-6xl">
              <PageTransition pathKey={location.pathname}>
                <Outlet />
              </PageTransition>
            </div>
          </main>
        </div>
      </div>
      {!isDesktop && <BottomNav />}
      <LevelUpModal />
      <AchievementToastHost />
      <PWAUpdatePrompt />
    </div>
  );
}
